var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurger(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMThIMjBDMjAuNTUgMTggMjEgMTcuNTUgMjEgMTdDMjEgMTYuNDUgMjAuNTUgMTYgMjAgMTZINEMzLjQ1IDE2IDMgMTYuNDUgMyAxN0MzIDE3LjU1IDMuNDUgMTggNCAxOFpNNCAxM0gyMEMyMC41NSAxMyAyMSAxMi41NSAyMSAxMkMyMSAxMS40NSAyMC41NSAxMSAyMCAxMUg0QzMuNDUgMTEgMyAxMS40NSAzIDEyQzMgMTIuNTUgMy40NSAxMyA0IDEzWk0zIDdDMyA3LjU1IDMuNDUgOCA0IDhIMjBDMjAuNTUgOCAyMSA3LjU1IDIxIDdDMjEgNi40NSAyMC41NSA2IDIwIDZINEMzLjQ1IDYgMyA2LjQ1IDMgN1oiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };